import React from 'react';

import { Form } from 'semantic-ui-react';

class InputBar extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.state = {
      message: '',
    };
  }
  handleChange(e, { name, value }) {
    this.setState({ message: value });
  }
  handleKeyDown(event) {
    if (event.key === 'Enter') {
      event.preventDefault();
      this.handleSubmit();
    }
  }
  handleSubmit() {
    this.props.onSubmit(this.state.message);
    this.setState({
      message: '',
    });
  }
  render() {
    const { message } = this.state;
    return (
      <div>
        <Form size="tiny" onSubmit={this.handleSubmit}>
          <Form.Group>
            <Form.TextArea
              rows={1}
              autoHeight
              placeholder="Message"
              onChange={this.handleChange}
              onKeyDown={this.handleKeyDown}
              value={message}
              width={16}
            />
            {/* <Form.Button
              width={3}
              size="medium"
              fluid
              type="submit"
              primary
              icon="send"
            /> */}
          </Form.Group>
        </Form>
      </div>
    );
  }
}

export default InputBar;



// WEBPACK FOOTER //
// ./src/containers/Chat/components/ChatComponent/components/InputBar/index.jsx